import {DetailsPageAppProps} from '../app/interfaces'
import {connect} from '../runtime-context/context'
import {EventImage as Presentation} from './event-image'
import {EventImageOwnProps, EventImageStateProps} from './interfaces'

const mapRuntime = ({state}: DetailsPageAppProps): EventImageStateProps => {
  const {event} = state

  return {
    image: event.mainImage,
    alt: event.title,
  }
}

export const EventImage = connect<EventImageOwnProps, EventImageStateProps>(mapRuntime)(Presentation)
